import script from "./LayoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutPage.vue?vue&type=script&setup=true&lang=js"

import "./LayoutPage.vue?vue&type=style&index=0&id=6a960a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a960a12"]])

export default __exports__